// CLICK-TO-CALL (Stage 4.8f.4b): any number in the app calls through the docked phone — checked first (allowed → dialled at once;
// not → the phone's keypad, with the number and why). Shown only to someone with a phone line.
import { ButtonBase, Tooltip } from "@mui/material";
import { Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePhone } from "./phoneContext";

export default function CallButton({ number, name = "", label, variant = "icon", disabled = false, sx }) {
  const { t } = useTranslation("phone");
  const phone = usePhone();
  if (!phone.available || !number) return null;
  const text = label ?? (name ? t("callName", { name }) : t("callNumber", { number }));
  const onClick = (e) => { e.stopPropagation(); phone.dial(number, name); };
  if (variant === "button") {
    return (
      <ButtonBase onClick={onClick} disabled={disabled} aria-label={text}
        sx={{ gap: "6px", minHeight: 36, px: "12px", borderRadius: "10px", background: "var(--success-bg)", color: "var(--success)", font: "700 13px/1 var(--font-ui)",
          "&:focus-visible": { outline: "2px solid var(--brand-violet)", outlineOffset: 2 }, ...sx }}>
        <Phone size={15} aria-hidden="true" />{label ?? t("call")}
      </ButtonBase>
    );
  }
  return (
    <Tooltip title={text}>
      <span>
        <ButtonBase onClick={onClick} disabled={disabled} aria-label={text}
          sx={{ width: 32, height: 32, borderRadius: "8px", color: "var(--success)", "&:hover": { background: "var(--success-bg)" },
            "&:focus-visible": { outline: "2px solid var(--brand-violet)", outlineOffset: 2 }, ...sx }}>
          <Phone size={15} aria-hidden="true" />
        </ButtonBase>
      </span>
    </Tooltip>
  );
}
